<template>
    <div class="push-meaasge-detail-wrap">
        <bread-crumb :bread-list="breadList" />
        <div class="push-meaasge-detail-content">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">{{pushId === 'add' ? '新增push' : 'push详情'}}</span>
            </div>
            <el-form :model="pushForm"
                     ref="bannerForm"
                     v-loading="loading"
                     label-width="122px"
                     class="push-form">
                <el-form-item label="">
                    <el-radio v-model="pushForm.type" label="inner">内链</el-radio>
                    <el-radio v-model="pushForm.type" label="outer">外链</el-radio>
                </el-form-item>
                <el-form-item label="push文案"
                              prop="text"
                              :rules="[{ required: true, message: '请输入push文案', trigger: 'change' }]">
                    <el-input v-model.trim="pushForm.text"
                              class="from-input"
                              placeholder="请输入push文案"
                              maxlength="30">
                    </el-input>
                </el-form-item>
                <el-form-item label="推送时间"
                              prop="pushTime"
                              :rules="[{ required: true, message: '请选择推送时间', trigger: 'change' }]">
                    <el-date-picker style="width:320px !important"
                                    :picker-options="pickerOptions"
                                    v-model="pushForm.pushTime"
                                    @change="handleUpdateTime"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    type="datetime"
                                    size="small"
                                    placeholder="选择推送时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item v-if="pushForm.type === 'inner'"
                              label="push跳转的URL"
                              prop="bannerTitle">
                    <!-- <el-input v-model.trim="pushForm.url"
                              class="from-input"
                              placeholder="请输入URL地址"
                              maxlength="200">
                    </el-input> -->
                    <el-select
                        class="from-input"
                        v-model="pushForm.url"
                        filterable
                        remote
                        reserve-keyword
                        placeholder="请输入关键词"
                        :remote-method="remoteMethod"
                        :loading="loadingUrl">
                        <el-option
                        v-for="item in ExpertSeminarList"
                        :key="item.expertSeminarId"
                        :label="item.title"
                        :value="item.expertSeminarId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                              v-if="pushForm.type === 'outer'"
                              label="push跳转的URL"
                              prop="bannerTitle">
                    <el-input v-model.trim="pushForm.url"
                              class="from-input"
                              placeholder="请输入URL地址"
                              maxlength="200">
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary"
                               class="submit-btn"
                               @click="submitForm('bannerForm')">提交</el-button>
                    <el-button @click="handleCandle"
                               class="cancle-btn">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
import { postEditPush, getPushDetail } from '@/api/pushMessage'
import { postExpertSeminarList } from '@/api/expert'
export default {
    name: 'pushMessageDetail',
    data () {
        return {
            pushId: this.$route.params.pushId,
            pickerOptions: {
                disabledDate (time) {
                    const now = new Date()
                    const preDate = new Date(now.getTime() - 8.64e7)
                    return time.getTime() < preDate
                }
            },
            loading: false,
            loadingUrl: false,
            breadList: [{ label: '运营管理' }, { label: 'push群发', path: '/operation/pushMessage' }, { label: '新增push' }],
            pushForm: {
                text: '',
                url: '',
                pushTime: '',
                type: 'inner',
                peoples: 'ALL'
            },
            options4: [],
            ExpertSeminarList: []
        }
    },
    mounted () {
        this.init()
    },
    methods: {
        async remoteMethod (query) {
            this.loadingUrl = true
            let params = {
                title: query,
                isUsed: 1, // 上线:1
                seminarType: 1, // 原创：1
                size: 50,
                current: 1
            }
            const { results, state } = await postExpertSeminarList(params)
            if (state === 200) {
                this.loadingUrl = false
                this.ExpertSeminarList = results
            }
            console.log(results, state)
        },
        handleCandle () {
            this.$router.push('/operation/pushMessage')
        },
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.savePush()
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        async savePush () {
            this.loading = true
            if (this.pushId !== 'add') {
                this.pushForm.pushId = this.pushId
            }
            const { results, state } = await postEditPush(this.pushForm)
            if (results && state === 200) {
                this.$message.success('提交成功！')
                this.$router.push('/operation/pushMessage')
            }
            this.loading = false
        },
        handleUpdateTime () {
            let pushTime = this.pushForm.pushTime
            // 多一秒缓冲
            if ((new Date(pushTime).getTime() < new Date().getTime() - 1 * 1000) && pushTime) {
                this.pushForm.pushTime = ''
                this.$message.warning('推送时间须大于等于当前时间')
                return false
            }
        },
        async getDetail () {
            this.loading = true
            const { state, results } = await getPushDetail(this.pushId)
            if (state === 200 && results) {
                let pushData = this.pushForm
                Object.keys(pushData).forEach(key => { pushData[key] = results[key] || pushData[key] })
            }
            this.loading = false
        },
        init () {
            this.breadList[2].label = this.pushId === 'add' ? '新增push' : 'push详情'
            if (this.pushId !== 'add') {
                this.getDetail()
            }
        }
    }
}
</script>
<style lang="scss">
.push-meaasge-detail-wrap {
    height: 100%;
    .push-meaasge-detail-content {
        min-height: calc(100% - 95px);
        box-shadow: 0 1px 4px 0 rgba(202, 202, 202, 0.5);
        margin: 20px;
        padding: 20px 20px 0 20px;
        background: #fff;
        .title-wrap {
            font-size: 0;
            padding-bottom: 20px;
            height: 16px;
            line-height: 16px;
            .icon-tongyongbiaotiicon {
                color: $color-primary;
                font-size: 16px;
                vertical-align: middle;
            }
            .title-text {
                font-size: 14px;
                color: #333333;
                margin-left: 10px;
                display: inline-block;
                height: 16px;
                line-height: 16px;
                vertical-align: middle;
            }
        }
        .push-form {
            .el-form-item__label {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
                letter-spacing: 0;
                padding-right: 20px;
            }
            .el-form-item__content {
                .from-input {
                    width: 320px;
                    .el-input__inner {
                        border-radius: 3px;
                        border: 1px solid #dcdcdc;
                        height: 32px;
                        padding: 0 10px;
                    }
                }
                .cover-content {
                    position: relative;
                    .cover-picture {
                        width: 339px;
                        height: 130px;
                    }
                    .icon-jinggaochacha {
                        cursor: pointer;
                        font-size: 16px;
                        color: #ec6a69;
                        position: absolute;
                        top: -15px;
                        left: 330px;
                    }
                }

                .picture-uploader {
                    width: 327px;
                    height: 130px;
                    background: #d8d8d8;
                    text-align: center;
                    .picture-content {
                        margin-top: 40px;
                        .icon-camera {
                            font-size: 24px;
                            color: #fff;
                        }
                        .picture_text {
                            margin-top: 2px;
                            font-family: PingFang-SC-Medium;
                            font-size: 14px;
                            color: #ffffff;
                            letter-spacing: 0;
                            line-height: 14px;
                        }
                    }
                }
                .uploader-tips {
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #999999;
                    letter-spacing: 0;
                    line-height: 16px;
                    font-weight: normal;
                    margin-top: 10px;
                }
                .form-datetime {
                    width: 320px;
                    .el-input__inner {
                        height: 32px;
                    }
                    .el-input__prefix {
                        .el-input__icon {
                            line-height: 32px;
                        }
                    }
                    .el-input__suffix {
                        .el-input__icon {
                            line-height: 32px;
                        }
                    }
                }
                .submit-btn {
                    width: 100px;
                    height: 32px;
                    border-radius: 3px;
                    padding: 0;
                }
                .cancle-btn {
                    width: 100px;
                    height: 32px;
                    border-radius: 3px;
                    padding: 0;
                    background: #f5f5f5;
                    border: 1px solid #cccccc;
                    color: #666;
                    margin-left: 16px;
                }
            }
        }
    }
}
</style>
